// src/services/regionalEntitiesService.js
import { fetchWithAuth } from "../utils/fetchWithAuth";

const BASE_MAIN = "/regional-entities";
const BASE_FALLBACK = "/api/regional-entities"; // se usa solo si el MAIN responde 404

const toQuery = (obj = {}) => {
  const p = new URLSearchParams();
  Object.entries(obj).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") p.append(k, v);
  });
  const s = p.toString();
  return s ? `?${s}` : "";
};

async function fetchEither(path, options = {}) {
  // 1) intenta sin /api
  let res = await fetchWithAuth(path, options);
  if (res.status !== 404) return res;

  // 2) si 404, intenta con /api (no toques Vite ni fetchWithAuth)
  const alt = path.startsWith(BASE_MAIN)
    ? path.replace(BASE_MAIN, BASE_FALLBACK)
    : path.startsWith(`${BASE_MAIN}/`)
    ? path.replace(BASE_MAIN, BASE_FALLBACK)
    : null;

  if (!alt) return res;
  const res2 = await fetchWithAuth(alt, options);
  return res2;
}

async function parseOrThrow(res) {
  const text = await res.text().catch(() => "");
  let data = {};
  try { data = text ? JSON.parse(text) : {}; } catch { /* ignore */ }
  if (!res.ok) throw new Error(data?.message || `HTTP ${res.status}`);
  return data;
}

// GET /regional-entities?search=&page=&limit=  (o /api/regional-entities...)
export const listRegionalEntities = async (filters = {}) => {
  const path = `${BASE_MAIN}${toQuery(filters)}`;
  const res = await fetchEither(path, { method: "GET" });
  const data = await parseOrThrow(res);
  return Array.isArray(data?.data) ? data : Array.isArray(data) ? { data, total: data.length, page: 1, limit: data.length } : data;
};

// GET /regional-entities/:id
export const getRegionalEntity = async (id) => {
  const path = `${BASE_MAIN}/${encodeURIComponent(id)}`;
  const res = await fetchEither(path, { method: "GET" });
  return await parseOrThrow(res);
};

// POST /regional-entities  (multipart o JSON)
export const createRegionalEntity = async (payload = {}) => {
  let options;

  if (payload instanceof FormData) {
    options = { method: "POST", body: payload };
  } else {
    const fd = new FormData();
    if (payload.scope) fd.append("scope", payload.scope); // 'national' | 'regional'
    if (payload.name) fd.append("name", payload.name);
    if (payload.region) fd.append("region", payload.region);
    if (payload.website) fd.append("website", payload.website);
    if (payload.description) fd.append("description", payload.description);
    if (payload.sector) fd.append("sector", payload.sector);
    if (payload.image instanceof File) fd.append("image", payload.image);
    options = { method: "POST", body: fd };
  }

  const res = await fetchEither(BASE_MAIN, options);
  return await parseOrThrow(res);
};

// PATCH /regional-entities/:id
export const updateRegionalEntity = async (id, payload = {}) => {
  let options;
  if (payload instanceof FormData) {
    options = { method: "PATCH", body: payload };
  } else {
    const body = {
      scope: payload.scope,
      name: payload.name,
      region: payload.region,
      website: payload.website,
      description: payload.description,
      sector: payload.sector,
    };
    options = {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    };
  }

  const res = await fetchEither(`${BASE_MAIN}/${encodeURIComponent(id)}`, options);
  return await parseOrThrow(res);
};

// DELETE /regional-entities/:id
export const deleteRegionalEntity = async (id) => {
  const res = await fetchEither(`${BASE_MAIN}/${encodeURIComponent(id)}`, { method: "DELETE" });
  if (res.status === 204) return { success: true };
  return await parseOrThrow(res);
};
